<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->
<mat-toolbar
  class="toolbar"
  [style.backgroundColor]="'var(--mat-sys-primary)'"
  [style.color]="'var(--mat-sys-on-primary)'"
  >
  <mat-toolbar-row>
    <span class="margin-auto">
      <a mat-icon-button style="outline: none; background-color: var(--mat-sys-on-primary);" [routerLink]="['/']">
        <mat-icon svgIcon="ic_crucible_caster"></mat-icon>
      </a>
    </span>
    <span class="view-text">{{ title }}</span>
    <span class="spacer"></span>
    @if (currentUser$ | async; as currentUser) {
      <div
        class="team-text flex-grow-1 d-flex justify-content-end align-items-center"
        >
        <button mat-button class="menu-trigger" [matMenuTriggerFor]="menu" style="outline: none">
          <strong>{{ currentUser.name }}</strong>
          <mat-icon aria-hidden="false" class="menu-trigger" fontIcon="mdi-chevron-down"></mat-icon>
        </button>
        <mat-menu #menu="matMenu" [overlapTrigger]="false">
          @if (projectId && (canManageProject$ | async)) {
            <a
              [routerLink]="['/projects', projectId, 'memberships']"
              mat-menu-item
              >
              Manage Project
            </a>
          }
          @if ((canViewAdmin$ | async) && topbarView === 'caster-admin') {
            <button
              (click)="exitAdmin()"
              mat-menu-item
              >
              Exit Administration
            </button>
          }
          @if (
            (canViewAdmin$ | async) && topbarView !== TopbarView.CASTER_ADMIN
            ) {
            <a
              [routerLink]="['/admin']"
              mat-menu-item
              >
              Administration
            </a>
          }
          <button mat-menu-item (click)="logout()">Logout</button>
          <mat-slide-toggle
            class="mat-menu-item"
            color="primary"
            [checked]="(theme$ | async) === 'dark-theme' ? true : false"
            (click)="$event.stopPropagation()"
            (change)="themeFn($event)"
            >
            Dark Theme
          </mat-slide-toggle>
        </mat-menu>
      </div>
    }
  </mat-toolbar-row>
</mat-toolbar>
